import { render, staticRenderFns } from "./AssessmentSettings.vue?vue&type=template&id=61766ff4&scoped=true"
import script from "./AssessmentSettings.vue?vue&type=script&lang=js"
export * from "./AssessmentSettings.vue?vue&type=script&lang=js"
import style0 from "./AssessmentSettings.vue?vue&type=style&index=0&id=61766ff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61766ff4",
  null
  
)

export default component.exports